import ButtonDetail from './button-detail.component'

export default ButtonDetail